import { c as _c } from "react/compiler-runtime";
import * as React from 'react';
const ArrowsRightLeftIcon = props => {
  const $ = _c(3);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <g id="solid/arrows-right-left"><path id="Icon" fillRule="evenodd" clipRule="evenodd" d="M15.8405 2.68762C15.5023 3.05186 15.5234 3.62132 15.8876 3.95954L18.4081 6.30003L8.10002 6.30003C7.60297 6.30003 7.20002 6.70297 7.20002 7.20003C7.20002 7.69709 7.60297 8.10003 8.10002 8.10003L18.4081 8.10003L15.8876 10.4405C15.5234 10.7787 15.5023 11.3482 15.8405 11.7124C16.1787 12.0767 16.7482 12.0978 17.1124 11.7595L21.3124 7.85954C21.4958 7.68925 21.6 7.45029 21.6 7.20003C21.6 6.94977 21.4958 6.71081 21.3124 6.54051L17.1124 2.64051C16.7482 2.30229 16.1787 2.32338 15.8405 2.68762ZM8.15954 12.2876C7.82132 11.9234 7.25186 11.9023 6.88762 12.2405L2.68762 16.1405C2.50423 16.3108 2.40002 16.5498 2.40002 16.8C2.40002 17.0503 2.50423 17.2893 2.68762 17.4595L6.88762 21.3595C7.25186 21.6978 7.82132 21.6767 8.15954 21.3124C8.49776 20.9482 8.47667 20.3787 8.11243 20.0405L5.59191 17.7H15.9C16.3971 17.7 16.8 17.2971 16.8 16.8C16.8 16.303 16.3971 15.9 15.9 15.9H5.59191L8.11243 13.5595C8.47667 13.2213 8.49776 12.6519 8.15954 12.2876Z" fill="currentColor" /></g>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== props) {
    t1 = <svg width={24} height={24} viewBox="0 0 24 24" fill="none" aria-hidden="true" {...props}>{t0}</svg>;
    $[1] = props;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
};
export default ArrowsRightLeftIcon;